/*=========================================================================================
  File Name: mails.js
  Description: mail neeeded for mail application
  Strucutre:
      id 
      sender name
      sender img
      Subject
      cc
      bcc
      message
      attachments - Array
      isStarred - bool
      labels - ['personal', 'company', 'important', 'work', 'private']
      time
      to - array
      replies - array of mails

      mailType - folder name
      *isTrashed - bool
      *isDrafted   - bool
      *isSent    - bool
      *isInboxed - bool
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/



export default [
  
]